const STORAGE_URL = `${import.meta.env.VITE_SUPABASE_STORAGE_URL}/storage/v1/object/public`;
const RENDER_URL = `${import.meta.env.VITE_SUPABASE_STORAGE_URL}/storage/v1/render/image/public`;

export function getStorageUrl(bucket: string, path: string) {
  return `${STORAGE_URL}/${bucket}/${path}`;
}

export function getImageUrl(
  bucket: string,
  path: string,
  options?: { width?: number; height?: number; quality?: number },
) {
  if (!options?.width && !options?.height) {
    return getStorageUrl(bucket, path);
  }
  const params = new URLSearchParams();
  if (options.width) params.set("width", String(options.width));
  if (options.height) params.set("height", String(options.height));
  if (options.quality) params.set("quality", String(options.quality));
  return `${RENDER_URL}/${bucket}/${path}?${params.toString()}`;
}
